import React, { useEffect, useState } from 'react';
import api from '../services/api';

const Zonas: React.FC = () => {
  const [clientes, setClientes] = useState<any[]>([]);
  const [facturas, setFacturas] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [zonaSeleccionada, setZonaSeleccionada] = useState<string>('todas');

  const cargar = async () => {
    setLoading(true);
    try {
      const [cliRes, facRes] = await Promise.all([api.get('/clientes'), api.get('/facturas')]);
      setClientes(cliRes.data);
      setFacturas(facRes.data);
    } catch {}
    finally { setLoading(false); }
  };

  useEffect(() => { cargar(); }, []);

  const zonas = ['todas', ...Array.from(new Set(clientes.map((c: any) => c.zona || 'General')))];

  const clientesFiltrados = zonaSeleccionada === 'todas'
    ? clientes
    : clientes.filter((c: any) => (c.zona || 'General') === zonaSeleccionada);

  const getDeuda = (clienteId: string) => {
    const hoy = new Date();
    return facturas.filter(f => f.clienteId === clienteId && (f.estado === 'pendiente' || f.estado === 'vencido') && new Date(f.fechaVencimiento) < hoy)
      .reduce((s: number, f: any) => s + Number(f.monto), 0);
  };

  const statsZona = (zona: string) => {
    const clis = zona === 'todas' ? clientes : clientes.filter((c: any) => (c.zona || 'General') === zona);
    const totalDeuda = clis.reduce((s, c) => s + getDeuda(c.id), 0);
    const morosos = clis.filter(c => getDeuda(c.id) > 0).length;
    return { total: clis.length, morosos, totalDeuda };
  };

  return (
    <div>
      <div style={{ marginBottom:24 }}>
        <h2 style={{ color:'#f1f5f9', margin:0, fontSize:24, fontWeight:800 }}>Zonas y Sectores</h2>
        <p style={{ color:'#64748b', margin:'4px 0 0', fontSize:13 }}>Gestion por zonas geograficas</p>
      </div>

      {/* Selector de zonas */}
      <div style={{ display:'flex', gap:8, flexWrap:'wrap', marginBottom:20 }}>
        {zonas.map(z => {
          const stats = statsZona(z);
          return (
            <button key={z} onClick={() => setZonaSeleccionada(z)}
              style={{ padding:'10px 16px', borderRadius:10, cursor:'pointer', fontWeight:700, fontSize:13,
                background: zonaSeleccionada === z ? '#0ea5e9' : '#1e293b',
                color: zonaSeleccionada === z ? 'white' : '#94a3b8',
                border: `1px solid ${zonaSeleccionada === z ? '#0ea5e9' : '#334155'}` }}>
              {z === 'todas' ? 'Todas las zonas' : z}
              <span style={{ marginLeft:8, background:'rgba(255,255,255,0.2)', borderRadius:20, padding:'2px 8px', fontSize:11 }}>
                {stats.total}
              </span>
            </button>
          );
        })}
      </div>

      {/* Stats de la zona */}
      {zonaSeleccionada !== 'todas' && (() => {
        const stats = statsZona(zonaSeleccionada);
        return (
          <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12, marginBottom:20 }}>
            {[
              { label:'Clientes', value: stats.total, color:'#38bdf8' },
              { label:'Morosos', value: stats.morosos, color:'#ef4444' },
              { label:'Deuda total', value: `S/. ${stats.totalDeuda.toFixed(2)}`, color:'#f59e0b' },
            ].map(s => (
              <div key={s.label} style={{ background:'#1e293b', borderRadius:10, padding:'14px 18px', border:`1px solid ${s.color}33` }}>
                <div style={{ color:'#64748b', fontSize:12 }}>{s.label}</div>
                <div style={{ color:s.color, fontSize:22, fontWeight:800 }}>{s.value}</div>
              </div>
            ))}
          </div>
        );
      })()}

      {/* Tabla clientes */}
      {loading ? <div style={{ color:'#64748b', textAlign:'center', padding:48 }}>Cargando...</div> :
        <div style={{ background:'#1e293b', borderRadius:12, overflow:'hidden', border:'1px solid #334155' }}>
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead>
              <tr style={{ background:'#0f172a' }}>
                {['Cliente','Zona','Plan','Estado','Deuda'].map(h => (
                  <th key={h} style={{ padding:'12px 16px', color:'#64748b', fontSize:12, fontWeight:600, textAlign:'left', borderBottom:'1px solid #334155' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {clientesFiltrados.map((c: any, i: number) => {
                const deuda = getDeuda(c.id);
                return (
                  <tr key={c.id} style={{ borderBottom:'1px solid #0f172a', background: deuda > 0 ? '#ef444408' : i % 2 === 0 ? 'transparent' : '#0f172a11' }}>
                    <td style={{ padding:'12px 16px' }}>
                      <div style={{ color:'#f1f5f9', fontWeight:600 }}>{c.nombres} {c.apellidos}</div>
                      <div style={{ color:'#64748b', fontSize:11 }}>{c.direccion || '—'}</div>
                    </td>
                    <td style={{ padding:'12px 16px' }}>
                      <span style={{ background:'#a78bfa22', color:'#a78bfa', border:'1px solid #a78bfa44', borderRadius:20, padding:'3px 10px', fontSize:12 }}>
                        {c.zona || 'General'}
                      </span>
                    </td>
                    <td style={{ padding:'12px 16px', color:'#38bdf8', fontSize:13 }}>{c.paquete?.nombre || '—'}</td>
                    <td style={{ padding:'12px 16px' }}>
                      <span style={{ background: c.estado === 'activo' ? '#22c55e22' : '#ef444422', color: c.estado === 'activo' ? '#22c55e' : '#ef4444', border:`1px solid ${c.estado === 'activo' ? '#22c55e44' : '#ef444444'}`, borderRadius:20, padding:'3px 10px', fontSize:12, fontWeight:700 }}>
                        {c.estado}
                      </span>
                    </td>
                    <td style={{ padding:'12px 16px', color: deuda > 0 ? '#ef4444' : '#22c55e', fontWeight:700, fontSize:14 }}>
                      {deuda > 0 ? `S/. ${deuda.toFixed(2)}` : 'Al dia'}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {clientesFiltrados.length === 0 && <div style={{ textAlign:'center', color:'#64748b', padding:32 }}>Sin clientes en esta zona</div>}
        </div>
      }
    </div>
  );
};

export default Zonas;